import React from 'react';

import { ReactComponent as InfoIcon } from '../../../assets/icons/info-icon-ne.svg';
import { ITagProps } from '../../interfaces/global';
import CustomTooltip from '../CustomTooltipNE/CustomTooltipNE';
import './Tag.scss';

const Tag = ({ text, type, tooltip, curved }: ITagProps) => {
  return (
    <div data-experience="new" className="flex flex-row items-center gap-2">
      <div className={`tag tag-${type} ${curved && 'curved'}`}> {text} </div>
      {tooltip && (
        <CustomTooltip placement={tooltip.placement} tooltipTitle={tooltip.tooltipTitle}>
          {tooltip.children ? tooltip.children : <InfoIcon className="tag-info-icon" />}
        </CustomTooltip>
      )}
    </div>
  );
};

export default Tag;
